import React from 'react';
import { Route } from 'react-router-dom';

import AccountSetupWizard from '../components/client-setup/AccountSetupWizard';
import AccountSetupNavigation from './AccountSetupNavigation';
import AuthenticatedRoutes from './AuthenticatedRoutes';

const listOfNavigation = [
  {
    path: '/account-setup/*',
    element: (
      <AccountSetupWizard>
        <AccountSetupNavigation />
      </AccountSetupWizard>
    ),
    key: 'account-setup'
  }
];

export default [
  <Route element={<AuthenticatedRoutes />} key="authenticated-routes">
    {listOfNavigation.map((route) => (
      <Route key={route.key} path={route.path} element={route.element} />
    ))}
  </Route>
];
